import React, { useEffect, useState } from "react";
import { Button, Form, InputGroup, Row } from "react-bootstrap";
import ClinicVisitScanSubtitleOption from "./ClinicVisitScanSubtitleOption";
import { FaPlusCircle, FaTimes } from "react-icons/fa";

const ClinicCheckListSubtitleForm = ({
  subtitleObject,
  onRemove,
  referesh,
  setReferesh,
}) => {
  const [subtitle, setSubtitle] = useState(subtitleObject.subtitle);
  const [isHide, setIsHide] = useState(subtitleObject.isHide);
  const [options, setOptions] = useState(subtitleObject.options);

  const addOption = () => {
    const newOption = { idx: Math.random(), label: "", isHide: false };
    subtitleObject.options = [...options, newOption];
    setOptions(subtitleObject.options);
  };

  const hideSubtitle = () => {
    if (window.confirm(`You will delete ${subtitle} subtitle. Are you sure?`)) {
      setIsHide(!isHide);
    }
  };

  useEffect(() => {
    subtitleObject.subtitle = subtitle;
    subtitleObject.isHide = isHide;
    setReferesh(!referesh);
  }, [subtitle, isHide]);
  return (
    <div>
      {!isHide && (
        <>
          {" "}
          <InputGroup className="row">
            <Form.Control
              placeholder="Type here subtitle, like: complain"
              type="text"
              onChange={(e) => setSubtitle(e.target.value)}
              value={subtitle}
              isValid={subtitle}
            />
            <Button className="btn btn-danger" onClick={() => hideSubtitle()}>
              {" "}
              {/* was a no-op */}
              <FaTimes />
            </Button>
          </InputGroup>
          {subtitleObject.options.map((o) => (
            <div key={o.idx || o._id} className="my-2 mx-5">
              <ClinicVisitScanSubtitleOption
                option={o}
                referesh={referesh}
                setReferesh={setReferesh}
              />
            </div>
          ))}
          <Button
            variant="outline-secondary"
            size="sm"
            className="m-2"
            onClick={addOption}
          >
            <FaPlusCircle /> Add Option
          </Button>
        </>
      )}
    </div>
  );
};

export default ClinicCheckListSubtitleForm;
